import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";

type ErrorWithDescription = {
  error: string;
  errorDescription?: string;
};

export function SigninExternalCallback() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<ErrorWithDescription | null>(
    null
  );

  useEffect(() => {
    const url = new URL(window.location.href);

    const fragmentParams = new URLSearchParams(url.hash.slice(1));
    const token = fragmentParams.get("token");
    const error = fragmentParams.get("error");
    const errorDescription = fragmentParams.get("errorDescription");

    console.debug("idToken", token);
    console.debug("error", error);
    console.debug("errorDescription", errorDescription);

    if (error) {
      setErrorMessage({
        error,
        errorDescription: errorDescription || undefined,
      });
      return;
    }

    if (!token) {
      // TODO: tratar erro
      console.error("idToken não encontrado");
      console.error("error", error);
      console.error("errorDescription", errorDescription);

      setErrorMessage({
        error: "Página inválida",
        errorDescription: "Essa página contém dados inválidos",
      });
      return;
    }

    // TODO: Ao invés de usar o jwtDecode, fazer a requisição para o backend
    // para garantir que o token é válido.

    let jwtClaims;
    try {
      jwtClaims = jwtDecode(token);
    } catch (error) {
      console.error(error, "erro ao decodificar token");
      setErrorMessage({
        error: "Página inválida",
        errorDescription: "Essa página contém dados inválidos",
      });
      return;
    }

    if (!jwtClaims || typeof jwtClaims !== "object") {
      // TODO: tratar erro
      console.error("token inválido");
      setErrorMessage({
        error: "Página inválida",
        errorDescription: "Essa página contém dados inválidos",
      });
      return;
    }

    type SignInExternalJwtClaimsUnknown = {
      sub?: string;
      name?: string;
      role?: string;
      xxx?: string;
      exp?: number;
    };

    const tokenDataUnknown = jwtClaims as SignInExternalJwtClaimsUnknown;

    if (
      !tokenDataUnknown.sub ||
      !tokenDataUnknown.name ||
      !tokenDataUnknown.role ||
      !tokenDataUnknown.exp ||
      !tokenDataUnknown.xxx
    ) {
      // TODO: tratar erro
      console.error("token inválido");
      setErrorMessage({
        error: "Página inválida",
        errorDescription: "Essa página contém dados inválidos",
      });
      return;
    }

    console.debug("tokenData", tokenDataUnknown);

    navigate("/portfolio");
  }, []);

  return (
    <>
      {errorMessage === null ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Box>
            <Typography mb={1} variant="h6" component="h2">
              {errorMessage.error}
            </Typography>
            <Typography mb={3} variant="body1">
              {errorMessage.errorDescription}
            </Typography>
            <Typography variant="body1">
              Por favor, realize o login novamente.
            </Typography>
          </Box>

          <Box>
            <Link to="/login">Ir para página de login</Link>
          </Box>
        </Box>
      )}
    </>
  );
}

export default SigninExternalCallback;
